export const loginRoute = (redirect?: string) =>
  `/login${redirect ? `?r=${redirect}` : ''}`;
export const registerRoute = (redirect?: string | string[]) =>
  `/register${redirect ? `?r=${redirect}` : ''}`;
export const requestResetRoute = () => '/request-reset';
